import { axios } from '@Root/API'

export const getForms = params => {
  return axios.get(`cognito-forms`, { params })
}
